module.exports = __webpack_public_path__ + "static/media/banner-home.2d954c61.png";